import {z} from 'zod';

import {ProvidersEnum} from '../../../../util/type';

export const onlinePresenceWarningHelpLinkKey = '^online-presence-warning$';

const onlinePresenceTemporaryProblemsConfigSchema = z.object({
    catalogs: z.array(z.nativeEnum(ProvidersEnum)),
    untilDate: z.string().refine((rawDate) => {
        try {
            return Boolean(new Date(rawDate));
        } catch {
            return false;
        }
    }),
});

type OnlinePresenceTemporaryProblemsConfigType = z.infer<typeof onlinePresenceTemporaryProblemsConfigSchema>;

export function isOnlinePresenceTemporaryProblemsConfig(
    config: unknown
): config is OnlinePresenceTemporaryProblemsConfigType {
    return onlinePresenceTemporaryProblemsConfigSchema.safeParse(config).success;
}

export function isConfigDateValid(configDate: string): boolean {
    const configDateObject = new Date(configDate);

    configDateObject.setHours(0, 0, 0, 0);
    const today = new Date();

    today.setHours(0, 0, 0, 0);

    return configDateObject >= today;
}
